import { logos } from '../utils/logos.js';
import { styles } from '../assets/styles';

export function Href1() {
  return (
    <div className="classic-container" style={styles.menuBoxContainer1}>
      <div style={styles.menuBoxClassic1}>
        <div style={styles.menuBoxClassic2}>
          <div style={styles.menuBoxClassic3}>
            <div style={styles.menuBoxClassic4}>
              <div style={styles.menuBoxClassic5}>
                <a className="hover" href="/classic" style={styles.href}>
                  <img src={logos.classicIcon} style={styles.hrefMargin} />
                  {' '}
                  <div style={styles.hrefTitleContainer}>
                    <span style={styles.hrefTitle}>CLASSIC</span>
                    <span style={styles.spanHref}>Get clues on every single try.</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Href2() {
  return (
    <div className="classic-container" style={styles.menuBoxContainer2}>
      <div style={styles.menuBoxCries1}>
        <div style={styles.menuBoxCries2}>
          <div style={styles.menuBoxCries3}>
            <div style={styles.menuBoxCries4}>
              <div style={styles.menuBoxCries5}>
                <a className="hover" href="/cries" style={styles.href}>
                  <img src={logos.playIcon} style={styles.hrefMargin} />
                  <div style={styles.hrefTitleContainer}>
                    <span style={styles.hrefTitle}>CRIES</span>
                    <span style={styles.spanHref}>Guess a POKéMON by its cry</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Href3() {
  return (
    <div className="classic-container" style={styles.menuBoxContainer2}>
      <div style={styles.menuBoxEmoji1}>
        <div style={styles.menuBoxEmoji2}>
          <div style={styles.menuBoxEmoji3}>
            <div style={styles.menuBoxEmoji4}>
              <div style={styles.menuBoxEmoji5}>
                <a className="hover" href="/emoji" style={styles.href}>
                  <img src={logos.emojiIcon} style={styles.hrefMargin} />
                  {' '}
                  <div style={styles.hrefTitleContainer}>
                    <span style={styles.hrefTitle}>EMOJI</span>
                    <span style={styles.spanHref}>Guess a POKéMON with a set of emojis</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
